import { memo } from "react";
import { TablePaginationProps } from "../../types";
import { ReactSVG } from "react-svg";
import React from "react";
import ModalBody from "ui/components/Modal/ModalBody";
import { Modal } from "ui/components/Modal";
import SortControl from "./SortControl";
import PaginationDisplayControl from "./PaginationDisplayControl";
import PaginationControl from "./PaginationControl";

const TablePagination: React.FC<TablePaginationProps> = (props) => {
  const {
    pagination,
    onChangePage,
    rowsSizeOptions,
    onChangeRowsSize,
    isMinimized,
  } = props;

  const [showModal, setShowModal] = React.useState(false);

  if (!pagination) return <></>;

  return (
    <>
      <div className="absolute top-1 left-2 right-2  xl:relative xl:left-0 xl:right-0">
        <div className="flex items-center xl:block mb-3">
          <div className="grow">
            <ReactSVG
              src="/media/icons/sort.svg"
              className="w-4 h-4 cursor-pointer xl:hidden stroke-[#222]"
              onClick={() => {
                setShowModal(!showModal);
              }}
            />
          </div>
          <div className="flex flex-col-reverse mt-2 px-3 xl:flex-row xl:justify-between xl:items-center">
            {!isMinimized && (
              <PaginationDisplayControl pagination={pagination} />
            )}

            <div className="flex">
              <div className="xl:block hidden xl:visible">
                <SortControl
                  rowsSizeOptions={rowsSizeOptions}
                  onChangeRowsSize={onChangeRowsSize}
                  width="small"
                />
              </div>
              <PaginationControl
                pagination={pagination}
                onChangePage={onChangePage}
              />
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <Modal show={showModal} className="" size="full">
          <ModalBody>
            <div className="text-center mb-3">
              <h3
                className="text-base font-semibold leading-6 text-[#344054]"
                id="modal-title"
              >
                Filter
              </h3>
            </div>
            <div className="mb-3">
              <SortControl
                rowsSizeOptions={rowsSizeOptions}
                onChangeRowsSize={onChangeRowsSize}
                width="large"
              />
            </div>
            <ReactSVG
              src="/media/icons/close.svg"
              className="w-6 h-6 cursor-pointer absolute top-3 right-3 stroke-[#888a97]"
              onClick={() => {
                setShowModal(!showModal);
              }}
            />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default memo(TablePagination);
